import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalStore } from 'app/shared/store/global.store';
import { PrimaryButtonComponent } from '../../controls/primary-button/primary-button.component';

@Component({
  imports: [PrimaryButtonComponent],
  selector: 'inpla-not-found',
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotFoundComponent {
  private readonly router: Router = inject(Router);

  public readonly globalStore = inject(GlobalStore);

  public navigateToMainPage(): void {
    this.router.navigate(['/']).then();
  }
}
